<template lang="html">
    <span
        class="lightest px-2 py-1 fs-normal radius-normal"
        :class="bgColor"
    >
        {{getPaymentState(paymentStateCode).label}}
    </span>
</template>

<script>
import {mapGetters} from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
export default {
    mixins: [reservationsMixin],
    props: {
        reservation: {
            type: Object
        }
    },
    computed: {
        ...mapGetters([
            'getPaymentState',
            'getReservationCalculations'
        ]),
        bgColor: function () {
            return 'bg-'+this.getPaymentState(this.paymentStateCode).color
        },
        atLeastOneRefundCodeToBeConfirmed() {
            // test if we have or not, at least one refund code to be confirmed/aprooved
            return this.reservation.refunds.some( r => r.isCodeConfirmed )
        },
        paymentStateCode: function () {
            let statusCode = null
            if (this.reservation.status == '-5' || this.reservation.changeStatusTo == '-5' || this.reservation.changeStatusTo == '-6') {
                if (this.getReservationCalculations.grandTotal > 0) {
                    statusCode = 3; //To Refund
                } else {
                    statusCode = 4; //Fully Refunded
                }
            } else {
                switch (true) {
                    case (this.getReservationCalculations.totalInDue > 0):
                        statusCode = 0; // In Due
                        break;
                    case (this.getReservationCalculations.totalInDue === 0):
                        statusCode = 1; // Paid
                        break;
                    case (this.getReservationCalculations.totalInDue  < 0):
                        statusCode = 2; // Overpaid
                        break;
                    default:
                        // Optional: Handle unexpected cases if necessary
                        break;
                }
            }

            return statusCode
        },
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// PaymentStatusBtn.vue?789d9b00